<template>
	<div class="modal fade" id="modalConsultaCliente" role="dialog" aria-labelledby="modal-cliente-label" aria-hidden="true">
		<div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
		    <div class="modal-content">
		      	<div class="modal-header">
		        	<h5 class="modal-title" id="modal-cliente-label">
		        		{{form.codigo}} | {{form.nombre}}
		        	</h5>
		        	<div class="btn-group">
				        <button type="button" class="btn btn-link" v-on:click="getCliente()">
				        	<i class="material-icons">refresh</i>
				        </button>
			        	<button type="button" class="btn btn-link" data-dismiss="modal" aria-label="Close">
				        	<i class="material-icons">close</i>
				        </button>
		        	</div>
		    	</div>
		    	<preloader v-if="loading"></preloader>
		    	<div class="modal-body py-0">
		    		<ul class="nav nav-tabs" id="ConsultaClientes" role="tablist">
						<li class="nav-item">
					    	<a class="nav-link active" id="personales-tab" data-toggle="tab" href="#personales" role="tab" aria-controls="personales" aria-selected="true">Datos Personales</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="empresas-tab" data-toggle="tab" href="#empresas" role="tab" aria-controls="empresas" aria-selected="false">Datos Empresas</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="contacto-tab" data-toggle="tab" href="#contacto" role="tab" aria-controls="contacto" aria-selected="false">Contacto</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" id="auditoria-tab" data-toggle="tab" href="#auditoria" role="tab" aria-controls="auditoria" aria-selected="false">
								Auditoría
							</a>
						</li>
					</ul>
					<div class="tab-content" id="ConsultaClientesContent">
						<div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">
							<div class="row py-3">
								<div class="col-md-4 mb-3">
									<label>Identificación:</label>
									<input 
										disabled
										v-model="form.identificacion"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-4 mb-3">
									<label>Fecha Nacimiento:</label>
									<input 
										disabled
										v-model="form.fecha_nacimiento"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-4 mb-3">
									<label v-text="configuracion.CLIENTES_NIT"></label>
									<input 
										disabled
										v-model="form.nit"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-6 mb-3">
									<label>Dirección:</label>
									<input 
										disabled
										v-model="form.direccion"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-6 mb-3">
									<label>Nombre Facturación:</label>
									<input 
										disabled
										v-model="form.nombre_facturacion"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-12 mb-3">
									<label>Notas:</label>
									<textarea 
										disabled
										v-text="form.notas"
										class="form-control form-control-sm">
									</textarea>
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="empresas" role="tabpanel" aria-labelledby="empresas-tab">
							<div class="row py-3">
								<div class="col-md-12 mb-3">
									<label>Corporación:</label>
									<input 
										disabled
										v-model="form.corporacion.descripcion"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-12 mb-3">
									<label>Puesto:</label>
									<input 
										disabled
										v-model="form.puesto"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-12 mb-3">
									<label>Segmento:</label>
									<input 
										disabled
										v-model="form.segmento.descripcion"
										class="form-control form-control-sm">
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="contacto" role="tabpanel" aria-labelledby="contacto-tab">
							<div class="row py-3">
								<div class="col-md-2 mb-3">
									<label>Teléfono:</label>
									<input 
										disabled
										v-model="form.telefono"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-2 mb-3">
									<label>Celular:</label>
									<input 
										disabled
										v-model="form.celular"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-4 mb-3">
									<label>Correo Electrónico:</label>
									<input 
										disabled
										v-model="form.email"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-4 mb-3">
									<label>Página Web:</label>
									<input 
										disabled
										v-model="form.facebook"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-6 mb-3">
									<label>Último Contacto:</label>
									<input 
										disabled
										v-model="form.ultimo_contacto"
										class="form-control form-control-sm">
								</div>
								<div class="col-md-6 mb-3">
									<label>Última Venta:</label>
									<input 
										disabled
										v-model="form.ultima_venta"
										class="form-control form-control-sm">
								</div>
							</div>
						</div>
						<div class="tab-pane fade" id="auditoria" role="tabpanel" aria-labelledby="auditoria-tab">
							<div class="row py-3">
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Creado Por'">
											<i class="material-icons">person_add</i>
										</div>
										<div class="media-body">
											<label>Creado Por:</label>
											<p class="m-0">
												{{form.creado_por.codigo}} - {{form.creado_por.nombre}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Actualizado Por'">
											<i class="material-icons">person_outline</i>
										</div>
										<div class="media-body">
											<label>Actualizado Por:</label>
											<p class="m-0">
												{{form.actualizado_por.codigo}} - {{form.actualizado_por.nombre}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Fecha Creación'">
											<i class="material-icons">access_time</i>
										</div>
										<div class="media-body">
											<label>Fecha Creación:</label>
											<p class="m-0">
												{{form.fecha_creacion}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Fecha Actualización'">
											<i class="material-icons">update</i>
										</div>
										<div class="media-body">
											<label>Fecha Actualización:</label>
											<p class="m-0">
												{{form.fecha_actualizacion}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Creado Desde'">
											<i class="material-icons">add_location</i>
										</div>
										<div class="media-body">
											<label>Creado Desde:</label>
											<p class="m-0">
												{{form.creado_desde}}
											</p>
										</div>
									</div>
								</div>
								<div class="col-md-6 mb-3">
									<div class="media">
										<div class="align-self-center mr-3" v-tooltip="'Actualizado Desde'">
											<i class="material-icons">edit_location</i>
										</div>
										<div class="media-body">
											<label>Actualizado Desde:</label>
											<p class="m-0">
												{{form.actualizado_desde}}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
		    	</div>
		    </div>
		</div>
	</div>
</template>
<script>
	export default {
		props: ['codigo'],

		mounted(){
			this.cliente = this.codigo;
        	if(this.cliente){
        		this.getCliente();
        	}
		},

		data(){
			return {
				cliente: '',
				loading: false,
				form: {
					codigo: '',
					nombre: '',
					tipo_cliente: '',
					identificacion: '',
					nit: '',
					celular: '',
					direccion: '',
					telefono: '',
					email: '',
					facebook: '',
					fecha_nacimiento: '',
					puesto: '',
					notas: '',
					ultimo_contacto: '',
					ultima_venta: '',
					fecha_creacion: '',
					fecha_actualizacion: '',
					creado_desde: '',
					actualizado_desde: '',
					nombre_facturacion: '',
					vendedor: {
						codigo: '',
						nombre: '',
					},
					segmento: {
						codigo: '',
						descripcion: '',
					},
					corporacion: {
						codigo: '',
						descripcion: '',
					},
					creado_por: {
						codigo: '',
						nombre: '',
					},
					actualizado_por: {
						codigo: '',
						nombre: '',
					},
					forma_pago: {
						codigo: '',
						descripcion: '',
					},
					mensajero: {
						codigo: '',
						nombre: '',
					},
				},
			}
		},

		methods: {
			getCliente: function(){
				this.loading = true;
				var url = 'api/clientes/'+this.codigo;

				axios.get(url)
				.then(response => {
					this.setData(response.data);
				}).catch(error => {
					console.log(error);
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			openModalConsulta: function(){
				this.getCliente();
				this.showModal();
			},

			setData: function(data){
				this.form.codigo = data.CODIGO_CLIENTE;
				this.form.nombre = data.NOMBRE_CLIENTE;
				this.form.tipo_cliente = data.TIPO_CLIENTE;
				this.form.identificacion = data.DOCTO_IDENTIFICA;
				this.form.nit = data.NIT;
				this.form.celular = data.CELULAR;
				this.form.direccion = data.DIRECCION;
				this.form.telefono = data.TELEFONO;
				this.form.email = data.EMAIL;
				this.form.facebook = data.USUARIO_FACEBOOK;
				this.form.fecha_nacimiento = data.FECHA_NACIMIENTO;
				this.form.puesto = data.PUESTO;
				this.form.notas = data.NOTAS;
				
				if (data.vendedor) {
					this.form.vendedor.codigo = data.vendedor.CODIGO_VENDEDOR;
					this.form.vendedor.nombre = data.vendedor.DESCRIPCION_VENDEDOR;
				}

				if (data.segmento) {
					this.form.segmento.codigo = data.segmento.CODIGO_SEGMENTO;
					this.form.segmento.descripcion = data.segmento.DESCRIPCION_SEGMENTO;
				}

				if (data.corporacion) {
					this.form.corporacion.codigo = data.corporacion.CODIGO_CORPORACION;
					this.form.corporacion.descripcion = data.corporacion.DESCRIPCION_CORPORACION;
				}

				this.form.ultimo_contacto = data.ULTIMO_CONTACTO;
				this.form.ultima_venta = data.ULTIMA_VENTA;
				this.form.fecha_creacion = data.FECHA_CREACION;
				this.form.fecha_actualizacion = data.FECHA_ACTUALIZACION;
				
				if (data.creado_por) {
					this.form.creado_por.codigo = data.creado_por.CODIGO_USUARIO;
					this.form.creado_por.nombre = data.creado_por.NOMBRE;
				}

				if (data.actualizado_por) {
					this.form.actualizado_por.codigo = data.actualizado_por.CODIGO_USUARIO;
					this.form.actualizado_por.nombre = data.actualizado_por.NOMBRE;
				}

				this.form.creado_desde = data.CREADO_DESDE;
				this.form.actualizado_desde = data.ACTUALIZADO_DESDE;
				this.form.nombre_facturacion = data.NOMBRE_FACTURACION;

				if (data.forma_pago) {
					this.form.forma_pago.codigo = data.forma_pago.CODIGO_FORMA_PAGO;
					this.form.forma_pago.descripcion = data.forma_pago.DESCRIPCION_FORMA_PAGO;
				}
				if (data.mensajero) {
					this.form.mensajero.codigo = data.mensajero.CODIGO_MENSAJERO;
					this.form.mensajero.nombre = data.mensajero.NOMBRE_MENSAJERO;
				}
			},

			showModal: function(){
				$('#modalConsultaCliente').modal('show');
			},

			closeModal: function(){
				$('#modalConsultaCliente').modal('hide');
			},
		},

        watch: {
        	codigo: function(val){
        		if (val) {
        			this.cliente = val;
        			this.getCliente();
        		}
        	},
  		},

  		computed: {
  			configuracion: function(){
  				return this.configuracionBase
  			}
  		}
	}
</script>